import React,{useState,useEffect} from 'react'
import NextICon from '../../images/icons/next.svg'
import PrevICon from '../../images/icons/prev.svg'
import './ScrollerStyles.css'
export default function ScrollerWithArrows(props) {

   
  const [childrenScrollEnabled, setChildrenScrollEnabled] = useState(false);
useEffect(()=>{
 //setSlideFeft += scrolling --> solved the arrow propblems
console.log(props,"props")
},[])
useEffect(()=>{
  var total_wid =0;
  //calculate childrenScrollEnabled --> width of 1 child * no of children > width ? scrollerArrowsEnabled = true :scrollerArrowsEnabled =false;
   const wid=(toDecimal(props.children&& props.children.props && props.children.props.children && props.children.props.children[0].props.style?.width))*100 || 100

  const len=props?.children?.props?.children?.length;
  if(len){
    total_wid=wid*len;
  }
  else{
    total_wid=wid;
  }
  if(total_wid>100)
  {
    setChildrenScrollEnabled(true)
     
  }
  if(total_wid<=100)
  {
    setChildrenScrollEnabled(false)
  }
},[])
function toDecimal(percent) {
  return parseFloat(percent) / 100;
}
const scrollerStyles ={
   
    display: 'flex',
    flexDirection: 'row',
    width:props.width
  }
  //write firstArrowStyles - dynamic based on props
  const firstArrowStyles ={
position:'relative',
top:'5rem',
left:0,
zIndex:999,
cursor:'pointer',
width:'fit-content',
height:'fit-content',
marginRight:'-8%',
  }
  const secondArrowStyles ={
position:'relative',
top:'5rem',
left:0,
zIndex:999,
cursor:'pointer',
width:'fit-content',
height:'fit-content',
marginLeft:'-8%',
  }
  //write secondArrowStyles - dynamic based on props
  // console.log(props.children.props.children.length,'ref cheek')
  const [slideLeft, setSlideLeft] = useState(0);
  const sliderWidth = 2000;
    //on arrow click
    const moveRight = () => {
      
      const el = document.getElementById(props.children.ref.current.id);
      // console.log(props.children.ref.clientWidth,'cheek props')
      setSlideLeft(el.scrollLeft += 150);
      
    };
  
    const moveLeft = () => {
      
      const el = document.getElementById(props.children.ref.current.id);
      setSlideLeft(el.scrollLeft -= 150);
     
    };
  return (
    
    <div style={scrollerStyles} className="ScrollerWithArrows">
{childrenScrollEnabled && slideLeft > 0 ?<img style={firstArrowStyles}  id="arrowScroller" src={PrevICon} onClick={moveLeft}/>:null}
      {props.children}
      {childrenScrollEnabled && slideLeft < sliderWidth ? <img style={secondArrowStyles} id="arrowScroller" src={NextICon} onClick={moveRight}/>:null}
    </div>
  )
}
